import React from "react";
import SeatManagementPage from "../../Components/SeatManagement/SeatManagementPage";

const EmotiiForTeamsPage = () => (
  <SeatManagementPage
    productSlug="emotii_for_teams"
    title="emotii for Teams"
    noAccessTitle="emotii for Teams Plans"
    subtitle="Manage seats, monitor usage, and collaborate across languages with your team."
    noAccessSubtitle="Choose a plan to unlock emotii for Teams and start managing seats for your team."
    deleteModalBody="Deleting this seat will immediately remove the user's access to emotii for Teams and permanently delete their associated data."
    bulkDeletePlatformName="emotii for Teams"
    emptyStateText="Invite users who can access emotii for Teams. Use the email addresses they log in to emotii with."
  />
);

export default EmotiiForTeamsPage;
